export default "__VITE_ASSET__$I0cnBeL__"